export const routes = [
  {
    key: 'Login',
    basePath: '/login',
    params: '',
    component: 'login',
    isDone: true,
  },
  {
    key: 'login_customer',
    basePath: '/login',
    params: '',
    component: 'Login_Customer',
    beforeDashboard: true,
    isDone: true,
  },
  {
    key: 'dashboard',
    basePath: '/dashboard',
    params: '',
    component: 'dashboard',
    isDone: true,
  },
  {
    key: 'GWEmergContacts',
    basePath: '/emergcontacts/GWEmergcontacts',
    onboardingKey: 'GWEmergContacts',
    params: '',
    component: 'Emerg_Contacts',
    isDone: true,
  },
  {
    key: 'GWEmergContactsUpd',
    basePath: '/emergcontacts/GWEmergContactsUpd/',
    onboardingKey: 'GWEmergContacts',
    params: ':recId',
    component: 'GWEmergContactsUpd',
    isDone: true,
  },
  {
    key: 'GWDependents',
    basePath: '/Dependents/GWDependents',
    onboardingKey: 'GWDependents',
    params: '',
    component: 'Dependents',
    isDone: true,
  },
  {
    key: 'GWDependentsUpd',
    params: ':recId',
    onboardingKey: 'GWDependents',
    basePath: '/Dependents/GWDependentsUpd/',
    component: 'GWDependents',
    isDone: true,
  },
  {
    key: 'GWFileUpdate',
    params: ':recId/:action',
    onboardingKey: 'GWDependents',
    basePath: '/Dependents/GWFileUpdate/',
    component: 'GWDependentsAddDoc',
    isDone: true,
  },
  {
    key: 'eepassword',
    params: '',
    basePath: '/eepassword',
    onboardingKey: 'GWPasswordUpd',
    component: 'EEpassword',
    isDone: true,
  },
  {
    key: 'eelanguage',
    params: '',
    basePath: '/eelanguage',
    component: 'EE_Language',
    isDone: true,
  },
  {
    key: 'GWEntitlements',
    params: '',
    basePath: '/entitlements/GWEntitlements',
    onboardingKey: 'GWEntitlements',
    component: 'PaidTimeOff',
    isDone: true,
  },
  {
    key: 'GWCheckEntitlements',
    params: ':recid',
    basePath: '/Entitlements/ProcessChoice/',
    onboardingKey: 'GWEntitlements',
    component: 'PaidTimeOffDetails',
    isDone: true,
  },
  {
    key: 'ddPrintDefault',
    params: '',
    basePath: '/ddPrintVoucher/ddPrintDefault',
    onboardingKey: 'ddPrintDefault',
    component: 'PrintPreference',
    isDone: true,
  },
  {
    key: 'GWEEDirDepUpd',
    params: ':recid',
    basePath: '/ddPrintVoucher/updateddPrintDefault/',
    onboardingKey: 'ddPrintDefault',
    component: 'UpdatePrintPreference',
    isDone: true,
  },
  {
    key: 'educationdefault',
    params: '',
    basePath: '/eeEducation/educationdefault',
    onboardingKey: 'educationdefault',
    component: 'Education',
    isDone: true,
  },
  {
    key: 'GWeducationUpd',
    params: ':recId',
    basePath: '/eeEducation/educationaddedit/',
    onboardingKey: 'educationdefault',
    component: 'EducationAddEdit',
    isDone: true,
  },
  {
    key: 'GWeducationView',
    params: ':recId',
    basePath: '/eeEducation/education/',
    onboardingKey: 'educationdefault',
    component: 'EducationDetails',
    isDone: true,
  },
  {
    key: 'salaryhistory',
    params: '',
    onboardingKey: 'salaryhistory',
    basePath: '/salaryhistory/salaryhistory',
    component: 'SalaryHistory',
    isDone: true,
  },
  {
    key: 'SalaryHistoryView',
    params: ':recId',
    onboardingKey: 'salaryhistory',
    basePath: '/salaryhistory/salaryhistorydetail/',
    component: 'SalaryHistoryDetail',
    isDone: true,
  },
  {
    key: 'GWNotificationElection',
    params: '',
    onboardingKey: 'GWNotificationElection',
    basePath: '/NotificationElection/GWNotificationElection',
    component: 'notificationElection',
    isDone: true,
  },
  {
    key: 'trnhistory',
    params: '',
    onboardingKey: 'trnhistory',
    basePath: '/trnhistory',
    component: 'TrainingClasses',
    isDone: true,
  },
  {
    key: 'trnenrollment',
    params: '',
    onboardingKey: 'trnenrollment',
    basePath: '/trnenrollment',
    component: 'TrainingEnrollment',
    isDone: true,
  },
  {
    key: 'GWPaycheckPayment',
    params: '',
    onboardingKey: 'GWPaycheckPayment',
    basePath: '/PayStub/GWPaycheckPayment',
    component: 'Paystub',
    isDone: true,
  },
  {
    key: 'GWPaycheckData',
    params: '',
    onboardingKey: 'GWPaycheckPayment',
    basePath: '/PayStub/ProcessChoice',
    component: 'PaystubDetails',
    isDone: true,
  },
  {
    key: 'GWPaycheckPrintPreview',
    params: ':recId',
    onboardingKey: 'GWPaycheckPayment',
    basePath: '/paystub/print/',
    component: 'PayStubPrintPreview',
    isDone: true,
  },
  {
    key: 'GWEEEMailAddr',
    onboardingKey: 'GWEEEMailAddr',
    params: '',
    basePath: '/eeemailaddr/GWEEEMailAddr',
    component: 'Email_Address',
    isDone: true,
  },
  {
    key: 'GWEEEMailAddrUpd',
    onboardingKey: 'GWEEEMailAddr',
    params: ':recId',
    basePath: '/eeemailaddr/EmailAddress/',
    component: 'EMailAddrAddUpdate',
    isDone: true,
  },
  {
    key: 'GWEEInfo',
    params: '',
    onboardingKey: 'GWEEInfo',
    basePath: '/eeinfo/GWEEinfo',
    component: 'PersonalData',
    isDone: true,
  },
  {
    key: 'GWEEInfoSubmit',
    params: '',
    onboardingKey: 'GWEEInfo',
    basePath: '/eeinfo/GWEEInfoSubmit',
    component: 'PersonalDataEdit',
    isDone: true,
  },
  {
    key: 'GWWebAppsLink',
    params: '',
    onboardingKey: 'GWWebAppsLink',
    basePath: '/webappslink/GWWebAppsLink',
    component: 'WorkforceManagement',
    isDone: true,
  },
  {
    key: 'gweeconsent',
    params: '',
    onboardingKey: 'gweeconsent',
    basePath: '/eeconsent/GWeeconsent',
    component: 'EEConsent1095C',
    isDone: true,
  },
    {
    key: 'gwEEConsent1095',
    params: '',
    onboardingKey: 'gwEEConsent1095',
    basePath: '/eeconsent/gwEEConsent1095',
    component: 'EEConsent1095C',
    isDone: true,
  },
  {
    key: 'gwEEConsentW2',
    params: '',
    onboardingKey: 'gwEEConsentW2',
    basePath: '/eeconsent/gwEEConsentW2',
    component: 'EEConsentW2',
    isDone: true,
  },
  {
    key: 'gwVolSelfIdDis',
    params: '',
    basePath: '/VolSelfIdDis/gwVolSelfIdDis',
    onboardingKey: 'gwVolSelfIdDis',
    component: 'VolSelfIdDis',
    isDone: true,
  },
  {
    key: 'gwVolSelfIdDisUpd',
    params: '',
    basePath: '/VolSelfIdDis/gwVolSelfIdDisUpd',
    onboardingKey: 'gwVolSelfIdDis',
    component: 'VolSelfIdDisUpd',
    isDone: true,
  },
  {
    key: 'eejobreviews',
    params: '',
    basePath: '/jobreviews/eejobreviews',
    onboardingKey: 'eejobreviews',
    component: 'JobReviews',
    isDone: true,
  },
  {
    key: 'GWeeconsentUpdSubmit',
    params: '',
    onboardingKey: 'gweeconsent',
    basePath: '/eeconsent/GWeeconsentUpdSubmit',
    component: 'EEConsentFormUpdate',
    isDone: true,
  },
    {
    key: 'GWeeconsentUpdSubmitW2',
    params: '',
    onboardingKey: 'gweeconsent',
    basePath: '/eeconsent/GWeeconsentUpdSubmitW2',
    component: 'EEW2ConsentFormUpdate',
    isDone: true,
  },
  {
    key: 'eejobreviewsdetail',
    params: ':recId',
    onboardingKey: 'eejobreviews',
    basePath: '/jobreviews/eejobreviewsdetail/',
    component: 'JobReviewsDetail',
    isDone: true,
  },
  {
    key: 'GWeeDirectory',
    params: '',
    onboardingKey: 'GWeeDirectory',
    basePath: '/eedirectory/GWeeDirectory',
    component: 'Employee_Direcotry',
    isDone: true,
  },
  {
    key: 'GWEECertif',
    params: '',
    onboardingKey: 'GWEECertif',
    basePath: '/eeCertif/GWEECertif',
    component: 'EECertifications',
    // beforeDashboard: true,
    isDone: true,
  },
  {
    key: 'GWEECertifSubmit',
    params: ':recId',
    onboardingKey: 'GWEECertif',
    basePath: '/eeCertif/GWEECertifSubmit/',
    component: 'CertificationsAddEdit',
    isDone: true,
  },
  {
    key: 'GWEEAddress',
    params: '',
    onboardingKey: 'GWEEAddress',
    basePath: '/eeaddress/GWEEAddress/',
    component: 'Address_Information',
    // beforeDashboard: true,
    isDone: true,
  },
  {
    key: 'GWEEAddressSubmit',
    params: ':recId',
    onboardingKey: 'GWEEAddress',
    basePath: '/eeaddress/GWEEAddressSubmit/',
    component: 'addInfoUpd',
    isDone: true,
  },
  {
    key: 'GWEEAddressW4',
    params: '',
    onboardingKey: 'GWEEAddress',
    basePath: '/eeaddress/GWEEAddressW4/',
    component: 'Address_Information_W4',
    isDone: true,
  },
  {
    key: 'GWEEFile',
    params: '',
    onboardingKey: 'GWEEFile',
    basePath: '/eefile/GWEEFile',
    component: 'Employee_Files',
    isDone: true,
  },
  {
    key: 'gePWRecover',
    params: '',
    basePath: '/passwordRecovery',
    component: 'PasswordRecovery',
    beforeDashboard: true,
    isDone: true,
  },
  {
    key: 'GWBftSummCurr',
    basePath: '/benefitstatement/BenefitStatement',
    params: '',
    onboardingKey: 'GWBftSummCurr',
    component: 'BenefitStatement',
    isDone: true,
  },
  {
    key: 'GWEEDirdep',
    params: '',
    basePath: '/eedirdep/GWEEDirDep',
    onboardingKey: 'GWEEDirdep',
    // beforeDashboard: true,
    component: 'DirectDepositAccount',
    isDone: true,
  },
  {
    key: 'GWEEDirDepDetail',
    params: '',
    basePath: '/eedirdep/GWEEDirDepDetail',
    onboardingKey: 'GWEEDirdep',
    component: 'DirectDepositAccountListing',
    isDone: true,
  },
  {
    key: 'GWEEDirDepAdd',
    params: '',
    basePath: '/eedirdep/GWEEDirDepAdd',
    onboardingKey: 'GWEEDirdep',
    component: 'AddUpdateAccount',
    isDone: true,
  },
  {
    key: 'GWEEDirDepUpdate',
    params: ':recId/:action',
    basePath: '/eedirdep/GWEEDirDepUpdate',
    onboardingKey: 'GWEEDirdep',
    component: 'AddUpdateAccount',
    isDone: true,
  },
  {
    key: 'GWEESkills',
    params: '',
    basePath: '/eeSkills/GWEESkills/',
    onboardingKey: 'GWEESkills',
    component: 'EESkills',
    isDone: true,
  },
  {
    key: 'GWEESkillsAddList',
    params: '',
    basePath: '/eeSkills/GWEESkillsAddList/',
    component: 'EESkillsAddList',
    onboardingKey: 'GWEESkills',
    isDone: true,
  },
  {
    key: 'GWEESkillsAddSubmit',
    params: '',
    basePath: '/eeSkills/GWEESkillsAddSubmit/',
    component: 'EESkillsAddSubmit',
    onboardingKey: 'GWEESkills',
    isDone: true,
  },
  {
    key: 'GWEESkillsUpdSubmit',
    params: ':recId',
    basePath: '/eeSkills/GWEESkillsUpdSubmit/',
    component: 'EESkillsUpdSubmit',
    onboardingKey: 'GWEESkills',
    isDone: true,
  },
  {
    key: 'goEXpassword',
    params: '',
    basePath: '/passwordExpiry',
    component: 'PasswordExpiry',
    beforeDashboard: true,
    isDone: true,
  },
  {
    key: 'goAcceptPolicy',
    params: '',
    basePath: '/acceptPolicy',
    component: 'AcceptPolicy',
    beforeDashboard: true,
    isDone: true,
  },
  {
    key: 'GWTotCompState',
    basePath: '/totCompState/GWTotCompState',
    params: '',
    component: 'Total_Compensation_Stmt',
    onboardingKey: 'GWTotCompState',
    isDone: true,
  },
  {
    key: 'GWW2History',
    params: '',
    basePath: '/W2History/GWW2History',
    onboardingKey: 'GWW2History',
    component: 'W2history',
    isDone: true,
  },
  /*-----FTE Start----*/
  {
    key: 'GWBftMenuFT',
    params: '',
    basePath: '/benefits/GWBftMenuFT/',
    component: 'BenefitsFTEMenu',
    onboardingKey: 'GWBftMenuFT',
    isDone: true,
  },
  {
    key: 'GWBftPersonalInfo',
    params: '',
    basePath: '/benefits/GWBftPersonalInfo/',
    component: 'BenefitsFTEPrsonalInfo',
    onboardingKey: 'GWBftMenuFT',
    isDone: true,
  },
  {
    key: 'GWBftDependents',
    params: '',
    basePath: '/benefits/GWBftDependents/',
    component: 'BenefitsFTEDependents',
    onboardingKey: 'GWBftMenuFT',
    isDone: true,
  },
  {
    key: 'GWBftVerify',
    params: '',
    basePath: '/benefits/GWBftVerify/',
    component: 'BenefitsFTEVerify',
    onboardingKey: 'GWBftMenuFT',
    isDone: true,
  },
  {
    key: 'GWBftElectBenefits',
    params: '',
    basePath: '/benefits/GWBftElectBenifits/',
    component: 'BenefitsFTEElectBenefits',
    onboardingKey: 'GWBftMenuFT',
    isDone: true,
  },
  {
    key: 'GWBftReview',
    params: '',
    basePath: '/benefits/GWBftReview/',
    component: 'BenefitsFTEReviewBenefits',
    onboardingKey: 'GWBftMenuFT',
    isDone: true,
  },
  {
    key: 'GWBftBenefits',
    params: '',
    basePath: '/benefits/GWBftBenifits/',
    component: 'BenefitsFTE',
    onboardingKey: 'GWBftMenuFT',
    isDone: true,
  },
  /*-----FTE End ----*/
  /*-----OPE Start ----*/
  {
    key: 'GWBftMenu',
    basePath: '/benefits/GWBftMenu/',
    params: '',
    component: 'BenefitsOPEMenu',
    onboardingKey: 'GWBftMenu',
    isDone: true,
  },
  {
    key: 'GWBOPPersonalInfo',
    params: '',
    basePath: '/benefits/GWBOPPersonalInfo/',
    component: 'BenefitsOPEPersonalInfo',
    onboardingKey: 'GWBftMenu',
    isDone: true,
  },
  {
    key: 'GWBOPDependents',
    params: '',
    basePath: '/benefits/GWBOPDependents/',
    component: 'BenefitsOPEDependents',
    onboardingKey: 'GWBftMenu',
    isDone: true,
  },
  {
    key: 'GWBOPVerify',
    params: '',
    basePath: '/benefits/GWBOPVerify/',
    component: 'BenefitsOPEVerify',
    onboardingKey: 'GWBftMenu',
    isDone: true,
  },
  {
    key: 'GWBOPElectBenefits',
    params: '',
    basePath: '/benefits/GWBOPElectBenifits/',
    component: 'BenefitsOPEElectBenefits',
    onboardingKey: 'GWBftMenu',
    isDone: true,
  },
  {
    key: 'GWBOPReview',
    params: '',
    basePath: '/benefits/GWBOPReview/',
    component: 'BenefitsOPEReviewBenefits',
    onboardingKey: 'GWBftMenu',
    isDone: true,
  },
  {
    key: 'GWBOPBenefits',
    params: '',
    basePath: '/benefits/GWBOPBenifits/',
    component: 'BenefitsOPE',
    onboardingKey: 'GWBftMenu',
    isDone: true,
  },
  /*-----OPE End ----*/
  {
    key: 'gwee1095form',
    params: '',
    basePath: '/ee1095form/gwee1095form',
    component: 'FormC1095',
    onboardingKey: 'gwee1095form',
    isDone: true,
  },
  /*-----beneficiaries Start ----*/
  {
    key: 'GWBnfBenefits',
    params: '',
    basePath: '/beneficiaries/GWBnfBenefits',
    component: 'Benefit_Beneficiaries',
    onboardingKey: 'GWBnfBenefits',
    isDone: true,
  },
  {
    key: 'GWBnfBenefitsDetail',
    params: ':recId',
    basePath: '/beneficiaries/GWBnfBenefitsDetail/',
    component: 'Benefit_Beneficiaries_Detail',
    onboardingKey: 'GWBnfBenefits',
    isDone: true,
  },
  {
    key: 'GWBnfBenefitsDetailUpd',
    params: ':recId',
    basePath: '/beneficiaries/GWBnfBenefitsDetailUpd/',
    component: 'Beneficiaries_Detail_Upd',
    onboardingKey: 'GWBnfBenefits',
    isDone: true,
  },
  /*-----beneficiaries End ----*/
  {
    key: 'NewsUpdate',
    params: '',
    basePath: '/gwmods/gwNews/ESSNews',
    component: 'Rendered_Web_Page',
    isDone: true,
  },
  {
    key: 'GWPayCalculator',
    params: '',
    basePath: '/PayCalculator/GWPayCalculator',
    component: 'PaycheckCalculator',
    onboardingKey: 'GWPayCalculator',
    isDone: true,
  },
  {
    key: 'GWPayCalculatorResult',
    params: '',
    basePath: '/PayCalculator/GWPayCalculatorResult',
    component: 'PaycheckCalculatorResult',
    onboardingKey: 'GWPayCalculator',
    isDone: true,
  },
  /*-----RetirementDeduction Start ----*/
  {
    key: 'RetDedDefault',
    params: '',
    basePath: '/RetDed/RetDedDefault',
    component: 'Retirement_Deduction',
    onboardingKey: 'RetDedDefault',
    isDone: true,
  },
  {
    key: 'RetDedAddSubmit',
    params: ':recId',
    basePath: '/RetDed/RetDedAddSubmit/',
    component: 'Retirement_Deduction_Add',
    onboardingKey: 'RetDedDefault',
    isDone: true,
  },
  {
    key: 'GWSymmetryW4',
    params: '',
    basePath: '/SymmetryW4/GWSymmetryW4/',
    component: 'W4_Forms',
    onboardingKey: 'GWSymmetryW4',
    isDone: true,
  },
    {
    key: 'GWSymmetryFed',
    params: '',
    basePath: '/SymmetryW4/GWSymmetryFed/',
    component: 'W4_Forms_fed',
    onboardingKey: 'GWSymmetryFed',
    isDone: true,
  },
  {
    key: 'GWSymmetryW4Add',
    params: '',
    basePath: '/SymmetryW4/GWSymmetryW4Add/',
    component: 'W4_Forms_date',
    onboardingKey: 'GWSymmetryW4',
    isDone: true,
  },
  {
    key: 'GWSymmetryW4Iframe',
    params: '',
    basePath: '/SymmetryW4/GWSymmetryW4Frame/',
    component: 'W4_Forms_iframe',
    onboardingKey: 'GWSymmetryW4',
    isDone: true,
  },
  /*-----RetirementDeduction End ----*/
  /*-----Onboarding Start ----*/
  {
    key: 'Onboarding',
    params: '',
    basePath: '/onboarding',
    component: 'Onboarding',
    beforeDashboard: true,
    isDone: true,
  },
  /*-----Onboarding End ----*/
  /*-----I-9 Start----*/
  {
    key: 'I9InfoList',
    onboardingKey: 'I9InfoList',
    params: '',
    basePath: '/I9Info/I9InfoList/',
    component: 'listingI9Listing',
    isDone: true,
  },
  {
    key: 'summaryList',
    onboardingKey: 'I9InfoList',
    params: '',
    basePath: '/I9Info/summaryList/',
    component: 'I9ListMenu',
    isDone: true,
  },
  {
    key: 'readInstruction',
    onboardingKey: 'I9InfoList',
    params: '',
    basePath: '/I9Info/readInstruction/first',
    component: 'I9FirstReadInstruction',
    isDone: true,
  },
  {
    key: 'perosnalInfo',
    onboardingKey: 'I9InfoList',
    params: '',
    basePath: '/I9Info/perosnalInfo/second',
    component: 'I9SecondPersonalInfo',
    isDone: true,
  },
  {
    key: 'immigration',
    onboardingKey: 'I9InfoList',
    params: '',
    basePath: '/I9Info/immigration/third',
    component: 'I9ThirdCitizenship',
    isDone: true,
  },
  {
    key: 'eligibility',
    onboardingKey: 'I9InfoList',
    params: '',
    basePath: '/I9Info/eligibility/fourth',
    component: 'I9FourthEligibility',
    isDone: true,
  },
  {
    key: 'I9EligibilityProceed',
    onboardingKey: 'I9InfoList',
    params: '',
    basePath: '/I9Info/eligibility/proceed',
    component: 'I9EligibilityProceed',
    isDone: true,
  },
  /*-----I-9 End----*/
  /*-----multi_factor_authentication Start ----*/
  {
    key: 'mfa_header',
    params: '',
    basePath: '/mfa',
    component: 'Mfa_header',
    isDone: true,
  },
  {
    key: 'mfa_login',
    params: ':mode',
    beforeDashboard: true,
    basePath: '/mfa/',
    component: 'Mfa_login',
    isDone: true,
  },
  /*-----multi_factor_authentication End ----*/
  {
    key: 'GWTax',
    params: '',
    basePath: '/W4Info/GWTax',
    component: 'W4',
    onboardingKey: 'GWTax',
    isDone: true,
  },
  {
    key: 'GWTaxDate',
    params: ':pageId',
    basePath: '/W4Info/GWTaxAdd/step/',
    component: 'W4_date',
    onboardingKey: 'GWTax',
    isDone: true,
  },
  /*-----Life Events Start ----*/
  {
    key: 'GWLifeEvents',
    basePath: '/lifeEvents/GWLifeEvents/',
    params: '',
    component: 'BenefitsLifeEventsList',
    onboardingKey: 'GWLifeEvents',
    isDone: true,
  },
  {
    key: 'GWLEMenu',
    params: '',
    basePath: '/lifeEvents/GWLEMenu/',
    component: 'BenefitsLifeEventsMenu',
    onboardingKey: 'GWLifeEvents',
    isDone: true,
  },
  {
    key: 'GWLEInfo',
    params: '',
    basePath: '/benefits/GWLEInfo/',
    component: 'BenefitsLifeEventsInfo',
    onboardingKey: 'GWLifeEvents',
    isDone: true,
  },
  {
    key: 'ProcessLE',
    params: '',
    basePath: '/benefits/ProcessLE/',
    component: 'BenefitsLifeEventsDependent',
    onboardingKey: 'GWLifeEvents',
    isDone: true,
  },
  {
    key: 'GWBLEVerify',
    params: '',
    basePath: '/lifeEvents/GWBLEVerify/',
    component: 'BenefitsLifeEventsVerify',
    onboardingKey: 'GWLifeEvents',
    isDone: true,
  },
  {
    key: 'GWLElectBenefits',
    params: '',
    basePath: '/benefits/GWLElectBenefits/',
    component: 'BenefitsLifeEventsElectBenefits',
    onboardingKey: 'GWLifeEvents',
    isDone: true,
  },
  {
    key: 'GWLEReview',
    params: '',
    basePath: '/benefits/GWLEReview/',
    component: 'BenefitsLifeEventsReview',
    onboardingKey: 'GWLifeEvents',
    isDone: true,
  },
  {
    key: 'GWLEBenefits',
    params: '',
    basePath: '/benefits/GWLEBenefits/',
    component: 'BenefitsLifeEvents',
    onboardingKey: 'GWLifeEvents',
    isDone: true,
  },
  /*-----Life Events End ----*/
  /*-----Payroll Information Custom Mod routes ----*/
  {
    key: 'GWPayInfo',
    params: '',
    basePath: '/PayInfo-MCTY/GWPayInfo',
    component: 'Payroll_Information_swp00073',
    onboardingKey: 'GWPayInfo',
    isDone: true,
  },
];
